import { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import * as BaseSizes from '../theme/Size';

/**
 * Scrollbar configuration object
 */
export const Config = {
  ThinWidth: BaseSizes.X2Small,
  NormalWidth: BaseSizes.XSmall,
} as const;

export const Default = css`
  ::-webkit-scrollbar,
  &::-webkit-scrollbar {
    width: ${utils.rem(Config.NormalWidth)};
  }

  ::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.Color.Neutrals.Border};
  }

  ::-webkit-scrollbar-track,
  &::-webkit-scrollbar-track {
    margin: ${({ theme }) => `${theme.Spacing.Size.MediumSmall}px;`};
  }

  /* Firefox */
  scrollbar-width: none;
  scrollbar-color: ${({ theme }) => theme.Color.Neutrals.Border} transparent;
`;

export const Panel = css`
  ::-webkit-scrollbar,
  &::-webkit-scrollbar {
    width: ${utils.rem(Config.ThinWidth)};
    height: ${utils.rem(Config.ThinWidth)};
  }

  ::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.Color.Neutrals.Border};
  }

  ::-webkit-scrollbar-track,
  &::-webkit-scrollbar-track {
    margin: ${({ theme }) => `${theme.Spacing.Size.MediumSmall}px;`};
  }

  /* Firefox */
  scrollbar-width: none;
  scrollbar-color: ${({ theme }) => theme.Color.Neutrals.Border} transparent;
`;

export const ThinScrollbar = css`
  ::-webkit-scrollbar,
  &::-webkit-scrollbar {
    width: ${utils.rem(Config.NormalWidth)};
  }

  ::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.Color.Neutrals.Dark};
  }

  ::-webkit-scrollbar-track,
  &::-webkit-scrollbar-track {
    margin: ${({ theme }) => `${theme.Spacing.Size.MediumSmall}px;`};
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.Color.Neutrals.Dark} transparent;
`;
